const Home = () => import('../views/Home.vue')

const route = {
    path: '/:hash?/:user_id?/:id?/:date?/:time_start?/:time_end?',
    name: 'Home',
    component: Home
}

export default route